import { render } from "./pb-pagebigtitle.vue?vue&type=template&id=67771c62"
import script from "./pb-pagebigtitle.vue?vue&type=script&lang=js"
export * from "./pb-pagebigtitle.vue?vue&type=script&lang=js"

import "./pb-pagebigtitle.vue?vue&type=style&index=0&id=67771c62&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__